import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactGA from "react-ga4";

import {
	WarrantyRecordsList
} from '../../components/warranty-records/';

class WarrantyRecords extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);
	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <WarrantyRecordsList />
					</Col>
				</Row>
			</div>
		);
	}
}

export default WarrantyRecords;
